<template>
  <div class="financial-product-edit">
    <!-- 头部 -->
    <header class="header">
      <h1>{{ isEdit ? "编辑贷款产品" : "发布贷款产品" }}</h1>
    </header>

    <!-- 主要内容区域 -->
    <div class="container">
      <div class="form-container">
        <el-form
          :model="form"
          ref="form"
          :rules="formRules"
          label-position="left"
          class="product-form"
        >
          <!-- 基本信息区域 -->
          <div class="section">
            <h2 class="section-title">基本信息</h2>

            <div class="form-group">
              <label class="label"
                >产品名称<span class="required">*</span></label
              >
              <div class="input-field">
                <el-input
                  v-model="form.ProductTitle"
                  placeholder="请输入产品名称"
                  :maxlength="50"
                  show-word-limit
                >
                </el-input>
                <div class="help-text">2-50字符</div>
              </div>
            </div>

            <div class="form-group">
              <label class="label">产品图标</label>
              <div class="input-field">
                <div
                  class="upload-area"
                  @click="
                    $refs.productIconUpload.$el
                      .querySelector('.el-upload__input')
                      .click()
                  "
                >
                  <el-upload
                    ref="productIconUpload"
                    class="upload-demo"
                    :action="uploadUrl"
                    :auto-upload="false"
                    :on-change="handleChange"
                    :file-list="fileList"
                    :show-file-list="false"
                    accept=".png,.jpg,.jpeg,.gif"
                    :disabled="loading"
                  >
                    <div class="upload-text">
                      <div class="main">点击上传图标</div>
                      <div>支持jpg/png/gif，≤2MB</div>
                    </div>
                  </el-upload>
                </div>
                <div v-if="logoUrl" class="file-preview">
                  <img
                    :src="'/api/admin/file/get?ossFilePath=' + logoUrl"
                    alt="产品图标"
                    class="product-icon"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="label"
                >所属机构<span class="required">*</span></label
              >
              <div class="input-field">
                <el-select
                  v-model="form.OrganizationItem"
                  value-key="deptId"
                  placeholder="请选择银行机构"
                  @change="handleOrganizationChange"
                  style="width: 400px"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.deptId"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="form-group">
              <label class="label"
                >产品类型<span class="required">*</span></label
              >
              <div class="input-field">
                <el-select
                  v-model="form.loanTypeIds"
                  placeholder="请选择产品类型"
                  multiple
                  clearable
                  style="width: 400px"
                >
                  <el-option
                    v-for="item in loanTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="form-group vertical">
              <label class="label">产品介绍</label>
              <div class="input-field wide">
                <el-input
                  type="textarea"
                  v-model="form.introduction"
                  placeholder="请输入产品详细介绍"
                  :maxlength="500"
                  :rows="4"
                  show-word-limit
                >
                </el-input>
                <div class="help-text">产品详细介绍，最多500字符</div>
              </div>
            </div>
          </div>

          <!-- 还款方式区域 -->
          <div class="section">
            <h2 class="section-title">
              还款方式<span class="required">*</span>
            </h2>
            <div class="checkbox-group">
              <el-checkbox-group v-model="form.repayType" style="display:flex;flex-direction:row;flex-wrap:wrap;gap:20px;">
                <el-checkbox
                  v-for="(item, index) in repay_type"
                  :key="index"
                  :label="item.value"
                  class="checkbox-item"
                >
                  {{ item.description }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <!-- 担保方式区域 -->
          <div class="section">
            <h2 class="section-title">
              担保方式<span class="required">*</span>
            </h2>
            <div class="checkbox-group">
              <el-checkbox-group v-model="form.creditType" style="display:flex;flex-direction:row;flex-wrap:wrap;gap:20px;">
                <el-checkbox
                  v-for="(item, index) in guarantee"
                  :key="index"
                  :label="item.value"
                  class="checkbox-item"
                >
                  {{ item.description }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <el-input
              v-if="IsDisable2 == '-1'"
              v-model="form.otherCretieType"
              placeholder="请输入担保方式"
              class="other-credit-input"
            >
            </el-input>
          </div>

          <!-- 贷款参数区域 -->
          <div class="section">
            <h2 class="section-title">贷款参数</h2>

            <div class="form-group">
              <label class="label"
                >贷款额度<span class="required">*</span></label
              >
              <div class="range-inputs">
                <div class="range-input">
                  <span>最小值</span>
                  <el-input
                    v-model="form.minMoney"
                    type="number"
                    placeholder="0"
                    min="0"
                    class="number-input"
                  >
                  </el-input>
                  <span class="unit">万元</span>
                </div>
                <div class="range-input">
                  <span>最大值</span>
                  <el-input
                    v-model="form.maxMoney"
                    type="number"
                    placeholder="0"
                    min="0"
                    class="number-input"
                  >
                  </el-input>
                  <span class="unit">万元</span>
                </div>
                <div v-if="MinMoney || MaxMoney" class="money-display">
                  <span class="col" v-if="MinMoney">{{ MinMoney }}~</span>
                  <span class="col">{{ MaxMoney }}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="label"
                >贷款期限<span class="required">*</span></label
              >
              <div class="range-inputs">
                <div class="range-input">
                  <span>最小值</span>
                  <el-input
                    v-model="form.minTime"
                    type="number"
                    placeholder="0"
                    min="1"
                    class="number-input"
                  >
                  </el-input>
                  <span class="unit">月</span>
                </div>
                <div class="range-input">
                  <span>最大值</span>
                  <el-input
                    v-model="form.maxTime"
                    type="number"
                    placeholder="0"
                    min="1"
                    class="number-input"
                  >
                  </el-input>
                  <span class="unit">月</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="label"
                >利率范围<span class="required">*</span></label
              >
              <div class="range-inputs">
                <div class="range-input">
                  <span>最小值</span>
                  <el-input
                    v-model="form.minRate"
                    type="number"
                    placeholder="0"
                    min="0"
                    step="0.01"
                    class="number-input"
                  >
                  </el-input>
                  <span class="unit">%</span>
                </div>
                <div class="range-input">
                  <span>最大值</span>
                  <el-input
                    v-model="form.maxRate"
                    type="number"
                    placeholder="0"
                    min="0"
                    step="0.01"
                    class="number-input"
                  >
                  </el-input>
                  <span class="unit">%</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务对象与申请条件区域 -->
          <div class="section">
            <h2 class="section-title">服务对象与申请条件</h2>

            <div class="form-group vertical">
              <label class="label">服务对象</label>
              <div class="input-field wide">
                <el-input
                  type="textarea"
                  v-model="form.serviceUser"
                  placeholder="请描述目标客户群体"
                  :maxlength="200"
                  :rows="3"
                  show-word-limit
                >
                </el-input>
                <div class="help-text">目标客户群体，最多200字符</div>
              </div>
            </div>

            <div class="form-group vertical">
              <label class="label">申请条件</label>
              <div class="input-field wide">
                <el-input
                  type="textarea"
                  v-model="form.applyCondition"
                  placeholder="请输入申请条件说明"
                  :maxlength="500"
                  :rows="4"
                  show-word-limit
                >
                </el-input>
                <div class="help-text">申请条件说明，最多500字符</div>
              </div>
            </div>

            <div class="form-group">
              <label class="label">相关附件</label>
              <div class="input-field">
                <div
                  class="upload-area"
                  @click="
                    $refs.attachmentUpload.$el
                      .querySelector('.el-upload__input')
                      .click()
                  "
                >
                  <el-upload
                    ref="attachmentUpload"
                    class="upload-demo"
                    :action="uploadUrl"
                    :auto-upload="false"
                    :on-change="handleChange2"
                    :file-list="fileList"
                    :show-file-list="false"
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                    multiple
                  >
                    <div class="upload-text">
                      <div class="main">上传产品相关文档</div>
                      <div>支持pdf/doc/docx/xls/xlsx，≤10MB</div>
                    </div>
                  </el-upload>
                </div>
                <div v-if="files.length > 0" class="file-preview">
                  <ul>
                    <li
                      v-for="(item, index) in files"
                      :key="index"
                      @click="AddFiles(item)"
                      class="file-item"
                    >
                      {{ item.FilesName }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- 启用状态区域 -->
          <div class="section">
            <h2 class="section-title">启用状态</h2>
            <div class="radio-group">
<el-radio-group v-model="form.radio" style="display:flex;flex-direction:row;flex-wrap:wrap;gap:20px;">
<el-radio label="1" class="radio-item">启用</el-radio>
<el-radio label="0" class="radio-item">禁用</el-radio>
</el-radio-group>
            </div>
          </div>

          <!-- 按钮组 -->
          <div class="button-group">
            <el-button @click="Cancel" class="btn btn-cancel">取 消</el-button>
            <el-button
              type="primary"
              @click="AddFinancialProduct"
              class="btn btn-primary"
            >
              {{ isEdit ? "保 存" : "发 布" }}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 图片上传
import { uploadFile } from "@/api/fileApi";
import { digitUppercase } from "@/util/numConvert";

// 所属机构接口,编辑新增接口,多选条件列表
import {
  BelongToTheOrganization,
  AddEdits,
  ScreeningCondition,
  DetailsFinancialProducts,
} from "@/api/RuralFinance";

export default {
  name: "FinancialProductEdit",
  data() {
    return {
      loanTypeList: [],
      loading: false, //上传文件的状态
      form: {
        loanTypeIds: [],
        ProductTitle: "", //产品名称
        OrganizationItem: {
          deptId: "",
          departName: "",
        }, //所属机构
        deptId: "",
        introduction: "", //产品介绍
        repayType: [], // 还款方式
        creditType: [], //担保方式
        minMoney: "", //最小钱数
        maxMoney: "", //最大钱数
        maxTime: "", //最大贷款期限
        minTime: "", // 最小贷款期限
        minRate: "", //最小利率
        maxRate: "", //最大利率
        serviceUser: "", //服务对象
        radio: "1", //启用状态
        applyCondition: "", //申请条件
        otherCretieType: "", //输入担保方式
        otherRepayType: "", //输入还款方式
        baseUrl: window.globalUrl.HOME_API,
      },
      formRules: {
        ProductTitle: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      rules: [],
      departName: "", //
      options: [], //所属机构列表
      fileList: [], //产品图标上传
      uploadUrl: `${window.globalUrl.HOME_API_WEI}/admin/file/upload`, //上传图片的地址
      logoUrl: "", //机构图标地址
      files: [], //相关文件列表
      checkList: ["0", "1"], //启用状态列表
      isEdit: false, //当前页面状态：编辑还是新增
      financeProductId: "", //编辑页的编号
      guarantee: [], //担保方式
      repay_type: [], //还款方式
      baseUrl: window.globalUrl.BASE_API,
    };
  },

  mounted() {
    // 先加载所属机构、还款方式和担保方式数据
    Promise.all([
      this.BelongOrganization(),
      this.Repayment(),
      this.ScreeningCondition(),
      this.getLoanTypeList(),
    ]).then(() => {
      // 如果有路由传入的产品ID，则自动进入编辑态并回显数据
      const id =
        (this.$route && this.$route.query && this.$route.query.financeProductId) ||
        (this.$route && this.$route.query && this.$route.query.id);
      if (id) {
        this.editObj(id, { financeProductId: id });
      }
    });
  },
  computed: {
    IsDisable1() {
      return this.form.repayType.indexOf("6");
    },
    IsDisable2() {
      return this.form.creditType.indexOf("5");
    },
    OrganizationItem() {
      return this.options.forEach((item) => {
        if (item.options == this.options) {
          return item;
        }
      });
    },
    //贷款最小金额
    MinMoney() {
      if (this.form.minMoney == 0) {
        return "";
      } else {
        return digitUppercase(this.form.minMoney);
      }
    },
    MaxMoney() {
      if (this.form.maxMoney == 0) {
        return "";
      } else {
        return digitUppercase(this.form.maxMoney);
      }
    },
    loanTypeOptions() {
      return this.loanTypeList.map((item) => ({
        id: item.id,
        name: item.label,
      }));
    },
  },
  methods: {
    //获取产品类型
    async getLoanTypeList() {
      await ScreeningCondition("loan_type").then((res) => {
        if (res.code == 0) {
          this.loanTypeList = res.data;
        }
      });
    },
    // 取消按钮
    Cancel() {
      this.$router.back();
    },
    // 多选对象
    ChangeObj() {
      this.options.forEach((item) => {
        if (item.options == this.options) {
          return item;
        }
      });
    },
    // 担保方式
    async ScreeningCondition() {
      let params = "credit_type";
      let res = await ScreeningCondition(params);
      this.guarantee = res.data;
    },
    // 还款方式
    async Repayment() {
      let params = "repay_type";
      let res = await ScreeningCondition(params);
      this.repay_type = res.data;
    },

    //所属机构
    async BelongOrganization() {
      let deptId = JSON.parse(localStorage.getItem("userInfo")).content.deptId;
      let res = await BelongToTheOrganization(deptId);
      this.options = res.data;

      this.form.OrganizationItem.deptId = res.data[0].deptId;
      this.form.OrganizationItem.departName = res.data[0].name;
    },
    //文件上传
    async handleChange2(file, fileList) {
      let param = new FormData();
      param.append("catalog", "financeAdd");
      param.append("file", file.raw);
      let res = await uploadFile(param);
      let FilesName = res.data.sourceFileName;
      let imgUrl = res.data.url;
      let item = {
        FilesName: FilesName,
        imgUrl: imgUrl,
      };
      this.files.push(item);
    },
    //新增附件下载功能
    async AddFiles(item) {
      const url = this.baseUrl + "admin/file/get?ossFilePath=" + item.imgUrl;
      let dom = document.createElement("a");
      dom.style.display = "none";
      dom.href = url;
      dom.setAttribute("download", item.FilesName);
      document.body.appendChild(dom);
      dom.click();
    },
    //图片上传
    async handleChange(file) {
      this.loading = true;
      let param = new FormData();
      param.append("catalog", "Chat");
      param.append("file", file.raw);
      let res = await uploadFile(param);
      if (res.code == 0) {
        this.$message.success(`${this.isEdit ? "编辑成功" : "上传成功"} `);
        let imgUrl = res.data.url;
        this.logoUrl = imgUrl;
        this.loading = false;
      } else {
        this.$message.error(`${this.isEdit ? "编辑失败" : "上传失败"}`);
        this.loading = false;
      }
    },

    //点击发布新增
    async AddFinancialProduct() {
      let files = JSON.stringify(this.files);
      let creditType = this.form.creditType.toString();
      let repayType = this.form.repayType.toString();
      if (this.form.OrganizationItem.deptId > 0) {
        let isTrue = false;
        // 检查还款方式是否为空
        if (this.form.repayType.length === 0) {
          this.$message.error("请勾选还款方式");
          this.isTrue = false;
          return false;
        } else {
          this.isTrue = true;
        }

        // 检查担保方式是否为空
        if (this.form.creditType.length === 0) {
          this.$message.error("请勾选担保方式");
          this.isTrue = false;
          return false;
        } else {
          this.isTrue = true;
        }
        const fieldsToValidate = [
          { key: "minMoney", label: "额度" },
          { key: "maxMoney", label: "额度" },
          { key: "minTime", label: "期限" },
          { key: "maxTime", label: "期限" },
          { key: "minRate", label: "利率" },
          { key: "maxRate", label: "利率" },
        ];

        // 使用Map来存储每个label的状态
        const validationStatus = { 额度: false, 期限: false, 利率: false };

        for (const { key, label } of fieldsToValidate) {
          if (this.form[key] && this.form[key] !== "0") {
            validationStatus[label] = true;
          }
        }

        // 检查每个label的状态，只要有一个为true即可通过校验
        for (const [label, status] of Object.entries(validationStatus)) {
          if (!status) {
            this.$message.error(`${label}不能为0`);
            this.isTrue = false;
            return false;
          } else {
            this.isTrue = true;
          }
        }

        if (this.isTrue) {
          let params = {
            financeProductId: this.financeProductId,
            title: this.form.ProductTitle,
            departId: this.form.OrganizationItem.deptId,
            departName: this.form.OrganizationItem.departName,
            status: this.form.radio,
            maxTime: this.form.maxTime,
            minTime: this.form.minTime,
            maxMoney: this.form.maxMoney,
            minMoney: this.form.minMoney,
            creditType: creditType,
            maxRate: this.form.maxRate,
            minRate: this.form.minRate,
            serviceUser: this.form.serviceUser,
            applyCondition: this.form.applyCondition,
            files: files,
            logoUrl: this.logoUrl,
            introduction: this.form.introduction,
            repayType: repayType,
            otherRepayDetail: this.form.otherRepayType,
            otherCretieType: this.form.otherCretieType,
            loanTypeIds: this.form.loanTypeIds.toString(),
          };

          let res = await AddEdits(params);

          //是否发布成功提示
          if (res.code == 0) {
            this.$message.success("发布成功");
            this.$router.back();
          } else {
            this.$message.info("发布失败");
          }
        }
      } else {
        this.$message.info("请选择所属机构");
      }
    },
    //做编辑功能 回显，有的按element要求的格式，重新定义
    async editObj(a, b) {
      let params = {
        financeProductId: b.financeProductId,
      };
      let res = await DetailsFinancialProducts(params);
      const obj = res.data[0];

      this.isEdit = true;
      let creditType = obj.creditType.split(",");
      let repayType = obj.repayType.split(",");
      this.form.ProductTitle = obj.title;

      // 先确保所属机构数据已加载
      if (this.options.length === 0) {
        await this.BelongOrganization();
      }

      // 从options中找到匹配的机构并设置为选中值
      const matchedOrg = this.options.find(
        (item) => item.deptId === obj.departId
      );
      if (matchedOrg) {
        this.form.OrganizationItem = matchedOrg;
      } else {
        // 如果找不到匹配的，则直接设置ID和名称
        this.form.OrganizationItem.deptId = obj.departId;
        this.form.OrganizationItem.departName = obj.departName;
      }

      this.financeProductId = a;
      // 与单选的 label 类型保持一致（字符串）
      this.form.radio = obj.status != null ? String(obj.status) : "1";
      this.form.maxTime = obj.maxTime == 0 ? null : obj.maxTime;
      this.form.minTime = obj.minTime == 0 ? null : obj.minTime;
      this.form.maxMoney = obj.maxMoney == 0 ? null : obj.maxMoney;
      this.form.minMoney = obj.minMoney == 0 ? null : obj.minMoney;
      this.form.maxRate = obj.maxRate == 0 ? null : obj.maxRate;
      this.form.minRate = obj.minRate == 0 ? null : obj.minRate;
      this.form.creditType = creditType;
      this.form.repayType = repayType;
      // 多选产品类型：后端返回逗号分隔字符串或单值，需解析为数组
      this.form.loanTypeIds =
        obj.loanTypeId && obj.loanTypeId != "0"
          ? String(obj.loanTypeId)
              .split(",")
              .filter(Boolean)
              .map((v) => Number(v))
          : [];

      this.form.introduction = obj.introduction;
      this.logoUrl = obj.logoUrl;
      this.form.applyCondition = obj.applyCondition;
      this.form.serviceUser = obj.serviceUser;
      this.form.otherCretieType = obj.otherCretieType;
      this.form.otherRepayDetail = obj.otherRepayType;
      this.files = JSON.parse(obj.files);
    },
    handleOrganizationChange(val) {
      if (val && val.name) {
        this.form.OrganizationItem.departName = val.name;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.financial-product-edit {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f6fa;
  padding: 20px;
}

.header {
  background: #fff;
  color: #34495e;
  padding: 10px 30px;
  border-bottom: 1px solid #ecf0f1;
  margin-bottom: 0;
  box-shadow: none;
  border-radius: 0;

  h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.form-container {
  padding: 30px;
  flex: 1;
  min-height: 0; // 允许在flex容器中收缩以启用滚动
  overflow-y: auto;
}

.section {
  margin-bottom: 40px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #34495e;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ecf0f1;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 60px;
    height: 2px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
}

.form-group {
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
  gap: 20px;

  &.vertical {
    flex-direction: column;
    align-items: stretch;
  }
}

.label {
  font-size: 14px;
  color: #2c3e50;
  min-width: 120px;
  padding-top: 8px;
  font-weight: 500;
}

.required {
  color: #e74c3c;
  margin-left: 5px;
}

.input-field {
  flex: 1;
  max-width: 400px;

  &.wide {
    max-width: 600px;
  }
}

.help-text {
  font-size: 12px;
  color: #7f8c8d;
  margin-top: 5px;
}

.checkbox-group,
.radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
}

.checkbox-item,
.radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
  }
}

.range-inputs {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.range-input {
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
    color: #2c3e50;
  }
}

.unit {
  font-size: 14px;
  color: #7f8c8d;
  font-weight: 500;
}

.upload-area {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: #3498db;
    background: #f0f8ff;
  }
}

.upload-text {
  color: #7f8c8d;
  font-size: 14px;

  .main {
    font-size: 16px;
    color: #34495e;
    margin-bottom: 5px;
  }
}

.file-preview {
  margin-top: 10px;
  padding: 10px;
  background: #f0f8ff;
  border-radius: 6px;
  font-size: 12px;
  color: #34495e;

  .file-item {
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #e3f2fd;
    }
  }
}

.money-display {
  margin-left: 20px;
}

.other-credit-input {
  margin-top: 15px;
}

.number-input {
  width: 120px;
}

.product-icon {
  max-width: 100px;
  max-height: 60px;
}

.button-group {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #ecf0f1;
}

.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  text-align: center;

  &-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    }
  }

  &-cancel {
    background: #95a5a6;
    color: white;

    &:hover {
      background: #7f8c8d;
    }
  }
}

.col {
  color: red;
  padding: 0px 5px;
}

.To {
  padding: 0px 5px;
}

// 响应式设计
@media (max-width: 768px) {
  .container {
    margin: 10px;
    border-radius: 8px;
  }

  .form-container {
    padding: 20px;
  }

  .form-group {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .label {
    min-width: auto;
    padding-top: 0;
  }

  .range-inputs {
    flex-direction: column;
    align-items: stretch;
  }

  .checkbox-group,
  .radio-group {
    flex-direction: column;
    gap: 10px;
  }

  .button-group {
    flex-direction: column;
  }

  .number-input {
    width: 100%;
  }

  .money-display {
    margin-left: 0;
    margin-top: 10px;
  }

  .range-input {
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
  }
}
</style>
